<style>
@import "../../assets/experience/css/style.css";

#afterCheckDeviceVI a {
  text-decoration: none;
  border: 1px solid;
  border-radius: 5px;
  padding: 6px;
  color: #fff;
  background: blue;
}
#back{
  float: left;
}
#connect {
  cursor: pointer;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}
</style>

<template>
  <div class="checkconnect1">
    <form id="checkConnectionForm" style="display: block; margin: 10px">
      <div id="div_image" style="width: 70%; align-items: center; margin: auto">
        <img alt="saban" src="../../assets/experience/image/saban1.png" />
        <!-- <img src="../../assets/experience/image/saban1.png" alt="saban" width="100%" height="100%"> -->
      </div>
      <div style="width: 100%; align-items: center; margin: auto">
        <br />
        <div id="afterCheckDeviceVI" style="display: none">
          <p
            id="checkconnectiontext"
            style="display: grid; text-align: center; font-weight: 500"
          >
            {{
              $t("message.system", {}, { locale: lang })
            }}&nbsp;&nbsp;&nbsp;&nbsp;
          </p>
          <div style="text-align: center">
            <input
              type="button"
              :value="$t('message.do_activity', {}, { locale: lang })"
              class="btn btn-primary btnconnection"
              id="connect"
              name="connect"
              v-on:click="gotoRunMission"
            />
            <!-- <router-link to="/experience">{{ $t('message.do_activity', {}, { locale: lang }) }}</router-link> -->
          </div>
        </div>
        <div id="beforeCheckDeviceVI" style="text-align: center">
          <p style="display: inline; font-weight: 500">
            {{
              $t("message.system_doing", {}, { locale: lang })
            }}&nbsp;&nbsp;&nbsp;&nbsp;
          </p>
          <div class="snippet" data-title=".dot-bouncing">
            <div class="stage">
              <div class="dot-bouncing"></div>
            </div>
          </div>
        </div>
      </div>
      <input
        type="button"
        :value="$t('message.back', {}, { locale: lang })"
        class="btn btn-primary"
        id="back"
        name="back"
        v-on:click="backToCheckMission"
      />
    </form>
  </div>
</template>

<script>
// import conf from "../../../public/config/vue/config.js";
import callFunction from "../../../public/common/vue/api/leanbot_js_api";
import checkConnectionExperience from "../../../public/common/vue/leanbot_check_connect.js";
// import app from '../../main'

export default {
  data() {
    return {
      lang: "en",
    };
  },
  mounted() {
    if (sessionStorage.getItem("lang") == "vi") {
      this.lang = "vi";
    } else {
      this.lang = "en";
    }
    checkConnectionExperience(this.$route.query);
  },
  methods: {
    gotoRunMission() {
      var dateTime = localStorage.getItem(
        "dateTime_" + sessionStorage.getItem("USERNAME")
      );
      const url1 = conf.api.meta_url + "/post";
      var method1 = "POST";
      var jsonBody1 = JSON.stringify({
        func: "95",
        body: {
          trangthai: 0,
          ngaytao: dateTime,
        },
      });
      var jsonRequest1 = btoa(jsonBody1);
      var getData1 = function (resp) {
        console.log(resp);

        window.location.href =
        window.location.origin + "/experience";
      };

      callFunction(url1, method1, jsonRequest1, getData1);
      // window.location.href =
      //   window.location.origin + "/#/experience?lang=" + this.lang;
      
    },
    backToCheckMission(){
      // window.location.href =
      //   window.location.origin + "/#/?lang=" + this.lang;
       window.location.href =
        window.location.origin;
    },
  },
};
</script>
